export default "__VITE_ASSET__9160c9cc__"